import { useAuth } from 'auth';
import superjson from 'superjson';
import useLocalStorage from 'use-local-storage';
import {
    TACTICAL_OPTION,
    ATHLETE_OPTION,
    TAG_OPTION,
    TIMING_OPTION,
    YES_OPTION,
    NO_OPTION,
    TAG_TYPE_OPTION,
    LABELS_WITHIN_TAG_OPTION,
} from './constants';

interface FocusStoredOptions {
    startImportOption: typeof TACTICAL_OPTION | typeof ATHLETE_OPTION | undefined;
    alignPeriodOption: typeof TAG_OPTION | typeof TIMING_OPTION | undefined;
    alignPeriodTagTypeSelection: string | undefined;
    athleteParticipationAssignOption: typeof YES_OPTION | typeof NO_OPTION | undefined;
    athleteParticipationType: typeof TAG_TYPE_OPTION | typeof LABELS_WITHIN_TAG_OPTION | undefined;
    importedTagAlias: Map<string, string>;
    syncToFocusMap: Map<string, string>;
    tagSelectedAthleteMap: Map<string, string>;
    labelSelectedAthleteMap: Map<string, string>;
    isBaking: boolean;
}

const defaultOptions: FocusStoredOptions = {
    startImportOption: undefined,
    alignPeriodOption: TIMING_OPTION,
    alignPeriodTagTypeSelection: '',
    athleteParticipationAssignOption: undefined,
    athleteParticipationType: undefined,
    importedTagAlias: new Map(),
    syncToFocusMap: new Map(),
    tagSelectedAthleteMap: new Map(),
    labelSelectedAthleteMap: new Map(),
    isBaking: false,
};

const useFocusPersistenceKey = () => {
    const { user } = useAuth();
    return `focus_options_v2_${user?.id}`;
};

const serializer = (obj: FocusStoredOptions | undefined): string => {
    return superjson.stringify(obj);
};

const parser = (str: string): FocusStoredOptions | undefined => {
    return superjson.parse(str);
};

const CONFIG = {
    serializer: serializer,
    parser: parser,
};

export const useFocusStoredOptions = () => {
    const KEY = useFocusPersistenceKey();
    const [focusStoredOptions, setFocusStoredOptions] = useLocalStorage<FocusStoredOptions>(
        KEY,
        defaultOptions,
        CONFIG,
    );

    return { focusStoredOptions, setFocusStoredOptions };
};
